import useDataFetcher from '~/components/useDataFetcher';
import type { AuthorityLevelInfo, DAConfigInfo } from '~/server_shared/openapi/data-contracts';

interface UseDelegatedAuthorityResult {
  isEnabled: boolean;
  levels: AuthorityLevelInfo[];
  isLoading: boolean;
  isError: boolean;
}

export function useDelegatedAuthority(organizationId: number): UseDelegatedAuthorityResult {
  const configRoute = `/sysconfig/api/v1/organizations/${organizationId}/delegated_authority/`;
  const {
    isLoading: isConfigLoading,
    isError: isConfigError,
    data: config,
  } = useDataFetcher<DAConfigInfo>(configRoute);

  const isEnabled = !!config?.enabled;
  const levelsRoute = `/sysconfig/api/v1/organizations/${organizationId}/delegated_authority/levels`;
  const {
    isLoading: isLevelsLoading,
    isError: isLevelsError,
    data: levels,
  } = useDataFetcher<AuthorityLevelInfo[]>(levelsRoute, null, { shouldFetch: isEnabled });

  return {
    isEnabled,
    levels: levels ?? [],
    isLoading: isConfigLoading || (isEnabled && isLevelsLoading),
    isError: isConfigError || isLevelsError,
  };
}
